import { MerchandiseMarketProduct } from '@epicuro-next/data/merchandise';
import { createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';

import { loadMarketingProductsSuccess } from '../../actions';
import { MarketingProductsState } from '../../models';

function selectProductId(product: MerchandiseMarketProduct): string {
  return product.productId;
}

export const marketingProductsAdapter: EntityAdapter<MerchandiseMarketProduct> =
  createEntityAdapter<MerchandiseMarketProduct>({
    selectId: selectProductId,
  });

export const initialState: MarketingProductsState = {
  marketingProducts: marketingProductsAdapter.getInitialState(),
};

const merchandiseMarketingReducer = createReducer(
  initialState,
  on(loadMarketingProductsSuccess, (state, { products }) => {
    const marketingProducts = marketingProductsAdapter.setAll(
      products,
      state.marketingProducts,
    );
    return { marketingProducts };
  }),
);

export function reducer(
  state: MarketingProductsState | undefined,
  action: Action,
) {
  return merchandiseMarketingReducer(state, action);
}
